import { render, staticRenderFns } from "./Certificate.vue?vue&type=template&id=4c97294a&scoped=true"
import script from "./Certificate.vue?vue&type=script&lang=js"
export * from "./Certificate.vue?vue&type=script&lang=js"
import style0 from "./Certificate.vue?vue&type=style&index=0&id=4c97294a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c97294a",
  null
  
)

export default component.exports